<ng-container *ngIf="enabled$ | async">
  <section
    #practiceAgentWidget
    id="practice-agent-widget"
    class="practice-agent-widget"
    [class.minimizing]="minimizing"
    [class.reopening]="reopening"
    [class.visible]="visible$ | async"
    [class.showing-status]="widgetStatus$ | async"
    [class.expanded]="expanded$ | async"
    [class.sidebar-open]="sidebarOpen$ | async"
    [class.wide-sidebar-open]="wideSidebarOpen$ | async"
    [attr.aria-hidden]="(visible$ | async) ? null : true"
    [attr.aria-busy]="(widgetStatus$ | async) === 'loading' ? true : null"
    aria-label="Practice Agent"
  >
    <div #widgetSurface class="widget-surface">
      <iframe
        #practiceAgentIframe
        class="practice-agent-frame"
        [src]="widgetUrl"
        title="Practice Agent"
        sandbox="allow-scripts allow-same-origin allow-forms"
        referrerpolicy="no-referrer"
        [attr.aria-hidden]="(widgetStatus$ | async) ? true : null"
        (load)="onIframeLoad()"
        (error)="bridgeService.handleIframeError()"
      >
      </iframe>
      <div *ngIf="widgetStatus$ | async as status" class="widget-status" role="status" aria-live="polite">
        <div class="widget-status-title">
          <mat-icon svgIcon="practice_agent" aria-hidden="true"></mat-icon>
          <strong>Practice Agent</strong>
        </div>
        <div class="widget-status-content">
          <span *ngIf="status === 'loading'" class="widget-spinner" aria-hidden="true"></span>
          <p>
            {{
              status === 'loading'
                ? 'Loading your cards...'
                : status === 'empty'
                  ? 'No cards available right now.'
                  : "We couldn't load your cards."
            }}
          </p>
          <button *ngIf="status !== 'loading'" mat-stroked-button color="primary" type="button" (click)="retry()">
            {{ status === 'empty' ? 'Check again' : 'Try again' }}
          </button>
        </div>
      </div>
      <div class="widget-controls" role="group" aria-label="Practice Agent controls">
        <div class="widget-actions">
          <button
            class="widget-control"
            [disabled]="minimizing || reopening"
            type="button"
            [matTooltip]="bridgeService.snoozeLabel"
            (click)="snooze()"
            [attr.aria-label]="bridgeService.snoozeLabel">
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <circle cx="12" cy="12" r="8.5"></circle>
              <path d="M9.5 9h5l-5 6h5"></path>
            </svg>
          </button>
        </div>
        <button
          class="widget-launch"
          [disabled]="minimizing || reopening"
          type="button"
          aria-label="Open Practice Agent (opens in a new tab)"
          (click)="openPracticeAgent()">
          <span>Open Practice Agent</span>
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M14 3h7v7M21 3l-11 11M10 3H3v18h18v-7"></path>
          </svg>
        </button>
        <div class="widget-actions">
          <button
            class="widget-control"
            [disabled]="minimizing || reopening"
            type="button"
            matTooltip="Close Practice Agent"
            (click)="dismiss()"
            aria-label="Close Practice Agent">
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="m7 7 10 10M17 7 7 17"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
    <span #notificationBadge class="widget-notification-badge" [class.has-count]="notificationCount > 0" aria-hidden="true">{{
      notificationCount > 99 ? '99+' : notificationCount
    }}</span>
  </section>
</ng-container>
